import React from 'react';
import CommonCard from '../CommonCard';
import DailyEnglishContent from './DailyEnglishContent';
import { DATA_TYPE, PREFERRED_ICON_TYPE } from '../../../../config/TypeConfig';
import languageManager from '../../../../utils/languageManager';

const DailyEnglish = ({ onSave }) => {
  const handleAdd = () => {
    // 组装每日英语卡片网站数据
    const websiteData = {
      name: languageManager.t('cards.dailyEnglish'),
      iconColor: '#4CAF50', // 绿色
      textIcon: 'EN',
      url: 'https://www.aidengta.cn',
      dataType: DATA_TYPE.DAILY_ENGLISH, // 使用枚举值代表每日英语卡片
      id: `dailyenglish_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`,
      iconUrl: '', // 每日英语卡片不需要图标URL
      preferredIconType: PREFERRED_ICON_TYPE.TEXT, // 使用枚举值表示文本图标
      category: languageManager.t('cards.dailyEnglish'), // 分类
      description: languageManager.t('cards.dailyEnglishDescription')
    };

    // 调用父组件的 onSave 方法
    if (onSave) {
      onSave(websiteData);
    }
  };

  return (
    <CommonCard
      title={languageManager.t('cards.dailyEnglish')}
      subtitle={languageManager.t('cards.dailyEnglishSubtitle')}
      onAdd={handleAdd}
      addButtonText={languageManager.t('common.add')}
      scrollDirection="vertical"
    >
      <DailyEnglishContent />
    </CommonCard>
  );
};

export default DailyEnglish;
